module.exports = __webpack_public_path__ + "img/Luis.86f513b8.jpg";